export default "__VITE_ASSET__AbvKi0MB__"